/**
 * /dashboard/hr/onboarding — Employee onboarding dashboard
 * (Phase 3c — 2026-06-01).
 *
 * Role-aware framing (the GET /hr/onboarding SQL scope is the real
 * boundary): an employee sees their own checklists; managers/HR get a
 * broader overview of their reports / the tenant.
 *
 * Migration note (2026-06-01, Next.js → Vite): port of
 * frontend/src/app/(dashboard)/dashboard/hr/onboarding/page.tsx +
 * layout.tsx, flattened into one route that uses HrModuleShell. Swaps:
 *   - "use client" dropped
 *   - The "Templates" admin link (→ Settings catalog) is DROPPED per
 *     SOP §8.3 + the Phase 3c spec — catalog admin moves to Settings in
 *     Phase 3g.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HrFeatureGate } from "@/components/hr/hr-feature-gate";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { OnboardingList } from "@/components/hr/onboarding-list";
import { useHrRoles } from "@/components/hr/use-hr-roles";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hr/onboarding/")({
  component: HrOnboardingRoute,
});

function HrOnboardingRoute() {
  const { isOnboardingOverview, defaultOnboardingView } = useHrRoles();

  return (
    <HrModuleShell
      title="Onboarding"
      description={
        isOnboardingOverview
          ? "Track onboarding for your reports and organisation."
          : "Track your onboarding checklists."
      }
    >
      <HrFeatureGate>
        <OnboardingList mode={defaultOnboardingView} />
      </HrFeatureGate>
    </HrModuleShell>
  );
}
